import login from 'views/login/login'
import resetPassword from 'views/login/resetPassword'
import resetPasswordSuccess from 'views/login/resetPasswordSuccess'
import verifyCodeGet from 'views/login/verifyCodeGet'
import verifyCodeLogin from 'views/login/verifyCodeLogin'
import forgotPassword from 'views/login/forgotPassword'
import register from 'views/register/register'
import PhoneCodeLogin from 'views/PhoneCodeLogin/PhoneCodeLogin' // 手机验证码登录

export const loginRegister = [
  {path: '/', name: 'login', component: login},
  {path: '/reset-password', name: 'resetPassword', component: resetPassword},
  {
    path: '/reset-password-success/:email',
    name: 'resetPasswordSuccess',
    component: resetPasswordSuccess
  },
  {path: '/verify-code-get', name: 'verifyCodeGet', component: verifyCodeGet},
  {
    path: '/verify-code-login/:email/:phone',
    name: 'verifyCodeLogin',
    component: verifyCodeLogin
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: forgotPassword
  },
  {path: '/register', name: 'register', component: register},
  {
    path: '/phone-code-login',
    name: 'PhoneCodeLogin',
    component: PhoneCodeLogin
  }
]
